<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="buy-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="buy-view">
                        <div class="exp-info">
                            <p>当前经验：<b>{{ exp_result() }}</b></p>
                            <p>本周可购经验：<b>{{ $store.state.account.canBuy }}</b></p>
                        </div>

                        <div class="block">
                            <el-slider
                            v-model="value"
                            :min="0"
                            :max="$store.state.account.canBuy"
                            :step="20"
                            >
                            </el-slider>

                            <div class="marks">
                                <div class="min">0</div>
                                <div class="max">{{ $store.state.account.canBuy }}</div>
                            </div>

                            <div class="manual">
                                <span>输入数量</span>
                                <el-input-number v-model="value" 
                                :min="0" :max="$store.state.account.canBuy"
                                :step=20
                                step-strictly
                                @input="number_fix()"
                                ></el-input-number>
                            </div>
                           
                        </div>

                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="closeModal"></div>
                        <div class="u-btn ok" @click="call_buy()">
                            <div class="sum">购买{{ value }}经验</div>
                            <div class="m3b">{{ value/20 }}梦三币</div>
                        </div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>     
</template>


<style scoped>
.buy-modal{
    position: relative;
    width: 715px;
    height: 470px;
    font-size: 24px;
    color: #6f3615;
    background-image: url(~@/assets/images/bg-exp_buy.png);
}

.title{
    width: 267px;
    height: 60px;
    margin: 15px auto 0;
    background-image: url(~@/assets/images/title-buy.png);    
}

.buy-view{
    padding: 10px 45px 0;
    line-height: 1.8;
    font-size: 24px;
    color: #8e492e;
    /* text-align: center; */
}

.exp-info{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.exp-info b{
    font-weight: 400;
    color: #8e492e;
}

.marks{
    display: flex;
    justify-content: space-between;
    margin-top: -10px;
}

.buy-view .block{
    padding: 15px;
}

.buy-view .icon{
    display: inline-block;
    width: 31px;
    height: 30px;
    margin: 0 5px;
    background-image: url(~@/assets/images/icon-m3b.png);
    vertical-align: sub;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 58px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 42px;
    box-sizing: border-box;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.cancel{
    width: 268px;
    height: 87px;
    background-image: url(~@/assets/images/btn-cancel.png);    
}

.u-ctrl .u-btn.ok{
    position: relative;
    width: 268px;
    height: 87px;
    padding: 12px;
    background-image: url(~@/assets/images/btn-buy.png);
    box-sizing: border-box;    
}

.u-btn .sum{
    font-size: 28px;
    color: #fff;
    text-align: center;
}

.u-btn .m3b{
    font-size: 22px;
    color: #fff;
    text-align: center;
}

.manual{
    display: flex;
    justify-content: center;
}

.manual span{
    padding-right: 20px;
}
</style>

<style>
.el-slider__runway{
    height: 10px;
    border: 1px solid #b87a53;
    border-radius: 5px;
    background-color: rgba(226, 198, 164, .8);
    /* box-shadow: 0 0 3px 3px rgba(184, 122, 83, .5); */
}

.el-slider__bar{
    height: 8px;
    background: linear-gradient(to right, #fcb85c, #fca756);
}

.el-slider__button{
    width: 43px;
    height: 43px;
    border: none;
    background-image: url(~@/assets/images/icon-circel.png);
    background-color: transparent;
}

.el-tooltip__popper.is-dark{
    font-size: 30px;
    color: transparent;
    font-weight: 700;
    background-color: transparent;
}

.el-tooltip__popper .popper__arrow{
    /* width: 12px;
    height: 21px;
    bottom: -10px;
    background-image: url(~@/assets/images/icon-arrow.png); 
    border: none; */
    display: none;
}

.el-tooltip__popper .popper__arrow::after{
    display: none;
}

.el-input{
    /* width: 345px; */
}

.el-input__inner{
    font-size: 24px;
}

.el-tooltip__popper{
    /* padding-top: 20px; */
    transform: translateY(20px);
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            gid : '1',
            giftName : '经验值',
            cost : 1,
            num : 1,
            score : 0,
            value : 0,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
        //console.log(this.$store.state.account.canBuy)
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        handleChange(value) {
            //console.log(value);
        },
        exp_result (){
            let vm = this;
            let max = vm.$store.state.account.week == -2 ? vm.$global.EXP[3] : vm.$global.EXP[vm.$store.state.account.week - 1];
            return Math.min( (vm.$store.state.account.buy +  vm.$store.state.account.killScore) ,  max);
        },
        number_fix(){
            if(isNaN(this.value) || this.value < 0){
                this.value = 0;
            }
        },                  
        buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            if(!this.value)return this.$toast('请选择购买数量');

            this.$axios.post(globalThis.ajax_url_map.buy,{
                giftId : this.gid,
                num : this.value/20,
            })
            .then(
                res => {
                    this.destroyElement ();                
                    this.$success_Modal({text : '成功获得'+ this.value +'经验'});
                    
                    //this.$store.commit("$_setFinishRate", this.value  + (this.$store.state.account.buy  +  this.$store.state.account.killScore));
                    this.$store.commit("$_setExp", this.value );
                    this.$update_task();
                    
                    //TODO refresh

                    //this.$update_userType(10)
                },
                rej => {
                    this.destroyElement ();
                    let type = rej.code == 416 ? 2 : 1;
                    this.$error_Modal({text : rej.message , type : type});
                },
            )

        },
        call_buy (){
            if(!this.value)return this.$toast('请选择购买数量');

            this.destroyElement (); 
            this.$comfirm_exp_Modal({ cost : this.value/20 });
        },        
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/BuyModal/buyModal.vue